import {
  HTMLProps,
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'

import { FieldError } from 'react-hook-form'

import clsx from 'clsx'

import s from 'shared/ui/phone-input/styles.module.scss'

import styles from './styles.module.scss'

interface Props extends HTMLProps<HTMLTextAreaElement> {
  error?: FieldError
  label?: string
  showLength?: boolean
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  (
    { placeholder, error, label, maxLength, onChange, showLength, ...props },
    ref,
  ) => {
    const innerRef = useRef<HTMLTextAreaElement>(null)
    const [length, setLength] = useState(0)

    useImperativeHandle(ref, () => innerRef.current as HTMLTextAreaElement)

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      setLength(e.target.value.length)
      onChange?.(e)
    }

    return (
      <div className={s.box}>
        {label && (
          <span className={clsx('semi-bold-14', s.label)}>{label}</span>
        )}
        <div
          className={clsx(
            styles.container,
            error && styles.error,
            showLength && styles.padding,
          )}
        >
          <textarea
            ref={innerRef}
            placeholder={placeholder}
            maxLength={maxLength}
            onChange={handleChange}
            {...props}
          />

          {showLength && (
            <div className={styles.lengthInfo}>
              {`${length}/${maxLength || 0}`}
            </div>
          )}
        </div>
      </div>
    )
  },
)

TextArea.displayName = 'TextArea'
